import type {
  SharedBudget,
  SharedBudgetServer,
  SharedBudgetServerPayload,
  SharedBudgetStats,
  SharedBudgetStatsCampaigns,
  SharedBudgetStatsCampaignsServer,
  SharedBudgetStatsServer,
} from '@metapic-apps/shared'

import { normalizeMoney, serializeMoney } from './common.adapter'

export const normalizeSharedBudget = (item: SharedBudgetServer): SharedBudget => ({
  id: item.id,
  title: item.title,
  currency: item.currency,
  consumedBudget: (item.consumed_budget || 0) / 100,
  amount: normalizeMoney(item.amount_v2),
  campaignsCount: item.campaigns_count,
})

export const normalizeSharedBudgets = (data: SharedBudgetServer[]) =>
  data.map(normalizeSharedBudget)

export const serializeSharedBudget = (budget: SharedBudget): SharedBudgetServerPayload => ({
  title: budget.title,
  amount: budget.amount.amount * 100,
  amount_v2: serializeMoney(budget.amount),
})

export const normalizeSharedBudgetStatsCampaigns = (
  campaigns: SharedBudgetStatsCampaignsServer,
): SharedBudgetStatsCampaigns => {
  return campaigns.map((c) => ({
    id: c.id,
    internalName: c.name,
    title: c.title,
    status: c.status,
    consumedBudget: c.consumed_budget / 100,
    ...(c.budget_limit && { budgetLimit: c.budget_limit / 100 }),
    ...(c.budget_limit_reached_at && { budgetLimitReachedAt: c.budget_limit_reached_at }),
  }))
}
export const normalizeSharedBudgetStats = (budget: SharedBudgetStatsServer): SharedBudgetStats => ({
  id: budget.id,
  title: budget.title,
  amount: normalizeMoney(budget.amount_v2),
  consumedBudget: budget.consumed_budget / 100,
  currency: budget.currency,
  campaignsCount: budget.campaigns_count,
  campaigns: normalizeSharedBudgetStatsCampaigns(budget.campaigns),
})
